// JsFromRoutes CacheKey 589506b720c3032498d039e4b67a610f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  recentlyAdded: /* #__PURE__ */ definePathHelper('get', '/consumer/favorites/recently_added'),
  syncGuestFavorites: /* #__PURE__ */ definePathHelper('post', '/consumer/favorites/sync_guest_favorites'),
  addToLists: /* #__PURE__ */ definePathHelper('post', '/consumer/favorites/:id/add_to_lists'),
  create: /* #__PURE__ */ definePathHelper('post', '/consumer/favorites'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/consumer/favorites/:id'),
}
